import { render, staticRenderFns } from "./ContractDocumentsTabContent.vue?vue&type=template&id=08171714&"
import script from "./ContractDocumentsTabContent.vue?vue&type=script&lang=ts&"
export * from "./ContractDocumentsTabContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports